import type { ApiResponse, HARD_CEILINGS, StandingAuthority } from '@evi/shared';
import { api } from './api';

/**
 * Standing authority in Admin (Warren, 29 Oct 2026, item 1): the Api's views (apps/api routes/settings/standing-authority.ts).
 * Super Admin only: the Api answers 403 to anyone else and the section then shows nothing. Whether the caller may loosen
 * anything is the Api's answer (owner.is_you), never the persona.
 */
export interface StandingAuthorityView {
  value: StandingAuthority & { shadow_started_at: string | null; updated_at: string | null; updated_by: string | null };
  hard_ceilings: typeof HARD_CEILINGS;
  make_good_mode_now: 'live' | 'shadow';
  owner: { name: string | null; is_you: boolean } | null;
  updated_by_name: string | null;
  month: { month: string; cap_cents: number; used_cents: number; person_cents: number; remaining_cents: number; by_currency: Record<string, number> };
}
export interface StandingActionRow {
  id: string; rule: string; kind: string; mode: 'live' | 'shadow'; status: string; reason: string | null; driver: string | null;
  money: { currency: string; cents: number } | null; approval_id: string | null; email: { outcome: string } | null; created_at: string;
}

export const fetchStandingAuthority = () => api.get('settings/standing-authority', { retry: 0 }).json<ApiResponse<StandingAuthorityView>>().then((r) => r.data!);
export const saveStandingAuthority = (value: StandingAuthority) =>
  api.put('settings/standing-authority', { json: value }).json<ApiResponse<{ value: StandingAuthorityView['value'] }>>().then((r) => r.data!.value);
export const fetchStandingActions = (limit = 20) =>
  api.get(`admin/standing-actions?limit=${limit}`, { retry: 0 }).json<ApiResponse<{ rows: StandingActionRow[] }>>().then((r) => r.data!.rows);

export { centsToDollars, dollarsToCents, monthLine, moneyLabel, standingActionLine } from './standingAuthorityView';
